import { useEffect, useState } from "react";
import { Card, Checkbox, Button, Avatar, Input, Typography, Radio } from "antd";
import CompanyLogo from "../../assets/images/for-company-logo.svg";
import ArrowImage from "../../assets/images/arrow-up-for-message.svg";
import TumbnailImage from "../../assets/images/for-tumbhnail-image.png";
import ArrowDownImage from "../../assets/images/arrow-down-image.svg";
import FeatureImage from "../../assets/images/feature-product-image.png";
import CoinImage from "../../assets/images/coin-image.svg";
import PlusImage from "../../assets/images/plus-image.svg";
import PlayerProfile from "../../assets/images/for-prodile-player.jpg";
import ClockImage from "../../assets/images/clock-image.svg";
import AuctionImage from "../../assets/images/auction-image.png";
import Main from "../../components/layout/Main";
import PoadcastcenterImage from "../../assets/images/POADCAST-CENTER-IMAGE.svg";
import { CrownOutlined } from "@ant-design/icons";
import LiveStreamCarousel from "../../components/forsliders";
import { usePodcast } from "../../context/PodcastContext";
import { useAuction } from "../../context/AuctionContext";
import {
  getAudioDuration,
  getDiffInTwoDate,
  isValidUrl,
} from "../../helper/functions";
import { useNavigate } from "react-router";
import { useTournament } from "../../context/TournamentContext";
import { useLeaderboard } from "../../context/LeaderboardContext";
import { useSettings } from "../../context/SettingsContext";
import { Severty, ShowToast } from "../../helper/toast";
import { useStore } from "../../context/StoreContext";
import { useChat } from "../../context/ChatContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import PlayerImage from "../../assets/images/leaderboard-profile.jpg";
import moment from "moment";
import { ImageNotAvailable } from "../../constants/urls";

const HomePage = () => {
  const { loadTournaments } = useTournament();
  const { loadLeaderboard } = useLeaderboard();
  const { addCartItem, getFeaturedProducts } = useStore();
  const { globalSearch } = useGlobalSearch();
  const [expanded, setExpanded] = useState(false);
  const [optionId, setOptionId] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [podcastexpanded, setPodcastExpanded] = useState(false);
  const [featuredexpanded, setFeaturedExpanded] = useState(false);
  const [auctionsexpanded, setAuctionsExpanded] = useState(false);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const [podcasts, setPodcasts] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [liveTournaments, setLiveTournaments] = useState([]);
  const [auctions, setAuctions] = useState([]);
  const navigate = useNavigate();

  // derived flags to hide empty sections while searching
  const hasLiveTournaments = liveTournaments?.length > 0;
  const hasUpcomingTournaments = tournaments?.length > 0;
  const hasFeaturedProducts = featuredProducts?.length > 0;
  const hasAuctions = auctions?.length > 0;
  const hasPodcasts = podcasts?.length > 0;

  const { loadPodCasts } = usePodcast();
  const { loadAuctions } = useAuction();
  const { getSurveys, voteSurvey } = useSettings();
  const { listenToGlobalThread, chatMessages, sendGlobalMessage } = useChat();
  const [params, setParams] = useState({});

  // ------------- handlers ------------
  const fetchPodcasts = async () => {
    try {
      const response = await loadPodCasts({ search: globalSearch });

      const allPodcastsData = response.data.all;

      const allPodcasts = await Promise.all(
        Object.keys(allPodcastsData).flatMap((categoryKey) => {
          return allPodcastsData[categoryKey].map(async (item) => {
            // get audio duration for this audio
            const duration = await getAudioDuration(item.audioUrl);

            return {
              _id: item._id,
              title: item.title,
              player: item.author,
              views: duration, // add audio duration here
              audioUrl: item.audioUrl,
              language: item.language,
              status: item.status,
              imageUrl: item.coverImageUrl,
              comments: item.comments,
              likes: item.likes,
              podcastId: item.podcastId,
              description: item.description,
              category:
                categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1),
              year: new Date(item.publishDate).getFullYear(),
            };
          });
        }),
      );

      setPodcasts(allPodcasts);
    } catch (error) {
      console.log("error-->", error);
    }
  };

  const fetchAuctions = async (filterType = null) => {
    try {
      if (filterType !== null) {
        setParams((prev) => ({
          ...prev,
          filterType: filterType,
          status: "Open",
        }));
      }

      if (globalSearch !== "") {
        setParams((prev) => ({
          ...prev,
          search: globalSearch,
        }));
      }

      const response = await loadAuctions(params);
      if (response.success) {
        setAuctions(response.data.items || response.data);
      }
    } catch (error) {
      console.error("Error fetching auctions:", error);
    }
  };

  const fetchTournaments = async () => {
    const response = await loadTournaments({
      status: "Upcoming",
      type: "public",
      search: globalSearch,
    });
    if (response.status === 200) {
      setTournaments(response.data.data.tournaments);
    }
    const responseLiveTournament = await loadTournaments({
      status: "Active",
      type: "public",
      search: globalSearch,
    });

    if (responseLiveTournament.status === 200) {
      setLiveTournaments(responseLiveTournament.data.data.tournaments);
    }
  };

  const fetchLeaderboard = async () => {
    try {
      const response = await loadLeaderboard();
      setLeaderboard(response.data.data.leaderboard);
    } catch (error) {
      console.log("Error fetching leaderboard", error);
    }
  };

  const fetchSurveys = async () => {
    try {
      const response = await getSurveys();
      if (response.status === 200) {
        setSurveys(response.data.surveys);
      }
    } catch (error) {
      console.error("Error fetching surveys:", error);
    }
  };

  const handleSurveySubmit = async (surveyId, optId) => {
    try {
      const data = {
        surveyId: surveyId,
        optionId: optId,
      };
      const response = await voteSurvey(data);
      if (response.status === 200) {
        ShowToast("Survey submitted successfully", Severty.SUCCESS);
        fetchSurveys();
      }
    } catch (error) {
      ShowToast(error.messages, Severty.ERROR);
      console.log("Error submitting survey:", error);
    }
  };

  const fetchFeaturedProducts = async () => {
    try {
      const response = await getFeaturedProducts({ search: globalSearch });
      if (response.status === 200) {
        setFeaturedProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching surveys:", error);
    }
  };

  const handleAddCartItem = async (id, quantity = 1) => {
    const response = await addCartItem(id, quantity);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
    } else {
      ShowToast(response.error, Severty.ERROR);
    }
  };

  const handleSend = async () => {
    if (!messageText.trim()) return;
    await sendGlobalMessage(messageText);
    setMessageText("");
  };

  // ----------- use effect ------------
  useEffect(() => {
    fetchPodcasts();
    fetchAuctions();
    fetchTournaments();
    fetchSurveys();
    fetchFeaturedProducts();
    listenToGlobalThread();
    fetchLeaderboard();
  }, [globalSearch]);

  return (
    <>
      <Main>
        <div className="for-note-message">
          🎮 Final Round Update: New Valorant tournament registrations are now
          open!
        </div>
        <LiveStreamCarousel />
        {/* ----------- Maze Compnay Logo --------- */}
        <div className="for-company-logo">
          <div>
            <img src={CompanyLogo} />
          </div>
          <div>
            <img src={CompanyLogo} />
          </div>
          <div>
            <img src={CompanyLogo} />
          </div>
          <div>
            <img src={CompanyLogo} />
          </div>
        </div>
        {/* ----------- Tournaments Section ----------- */}
        {(!globalSearch || hasLiveTournaments) && (
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Live Tournaments</div>

            <div
              className={`for-live-video-grid-wrapper ${
                expanded ? "expanded" : ""
              }`}
            >
              <div className="for-feature-grid-main">
                {!liveTournaments || liveTournaments.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                    }}
                  >
                    No tournaments found
                  </p>
                ) : (
                  (liveTournaments || [])
                    .slice(0, expanded ? liveTournaments.length : 5)
                    .map((item, index) => {
                      return (
                        <div key={index} className="for-live-video-grid-inner">
                          <div
                            className="for-live-video-grid-inner-image"
                            onClick={() =>
                              // navigate(
                              //   `/live-tournaments/tournaments-details/${item._id}`
                              // )
                              navigate(`/live-tournaments`)
                            }
                          >
                            <img
                              src={
                                isValidUrl(item.game.image)
                                  ? item.game.image
                                  : ImageNotAvailable
                              }
                              alt="thumbnail"
                            />
                            <span>{item.status}</span>
                            {/* <h5>2.4K watching</h5> */}
                          </div>

                          <div className="for-live-video-grid-footer">
                            <div className="player-profile">
                              <img src={PlayerProfile} alt="profile" />
                            </div>

                            <div className="for-player-text">
                              <h5>{item.game.name}</h5>
                              <p>{item.name_en}</p>

                              <div className="for-player-tags">
                                <span>{item.status}</span>
                                <span>{item.type}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                )}
              </div>
            </div>

            {/* ✅ Show button only if tournaments > 5 */}
            {tournaments && tournaments.length > 5 && (
              <div
                className="show-more-button"
                onClick={() => setExpanded(!expanded)}
              >
                <span className="line" />
                <h4>
                  {expanded ? "Show less" : "Show more"}{" "}
                  <img
                    src={ArrowDownImage}
                    alt="arrow"
                    style={{
                      transform: expanded ? "rotate(180deg)" : "rotate(0)",
                      transition: "0.3s",
                    }}
                  />
                </h4>
                <span className="line" />
              </div>
            )}
          </section>
        )}
        {/* ------------ Chat Section ------------------ */}
        {!globalSearch && (
          <section className="chat-section">
            <div className="chat-section-grid">
              {/* Left Sidebar */}
              <div className="chat-section-flex">
                {/* Survey Card */}

                {surveys.map((survey) => (
                  <Card
                    key={survey?._id}
                    className="for-chat-cards for-chat-cards-for-survey"
                  >
                    <div className="card-header-new">
                      <span>Survey</span>
                      <p>{survey?.question}</p>
                    </div>

                    {/* ✅ Use Radio.Group instead of Checkbox.Group */}
                    <Radio.Group
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: 16,
                      }}
                      value={
                        survey?.lastVotedOption
                          ? survey?.lastVotedOption
                          : optionId?.[survey?._id] || null
                      }
                      onChange={(e) =>
                        setOptionId((prev) => ({
                          ...prev,
                          [survey?._id]: e.target.value, // ✅ Single value, not array
                        }))
                      }
                    >
                      {survey.options.map((opt) => (
                        <Radio
                          key={opt?._id}
                          value={opt?._id}
                          style={{ color: "#fff", marginBottom: 8 }}
                        >
                          {opt.text}
                        </Radio>
                      ))}
                    </Radio.Group>

                    <Button
                      className="Fill-button submit-vote"
                      onClick={() =>
                        handleSurveySubmit(survey?._id, optionId[survey?._id])
                      }
                      disabled={survey.lastVotedOption}
                    >
                      {survey.lastVotedOption ? "Already Voted" : "Submit Vote"}
                    </Button>
                  </Card>
                ))}

                {/* Leaderboard */}
                <Card
                  title=""
                  className="for-chat-cards for-chat-cards-best-players"
                >
                  <div className="card-header-new">Best Players</div>
                  <div className="best-playes-list-main">
                    {leaderboard.map((player, index) => (
                      <div key={index} className="best-playes-list">
                        <div className="best-playes-list-inner">
                          <h6>{index + 1}</h6>
                          <Avatar
                            style={{ backgroundColor: "#6947ff" }}
                            icon={<CrownOutlined />}
                          />
                          <h5>{player.username}</h5>
                        </div>
                        <h3>{player.score}</h3>
                      </div>
                    ))}
                  </div>
                </Card>
              </div>

              <Card className="for-chat-cards for-chat-cards-for-chat">
                <div className="card-header-new">Thread</div>

                <div className="chat-body">
                  {chatMessages.map((msg, idx) => {
                    const isRight =
                      msg.senderId == userProfile?._id ? true : false;
                    return (
                      <div
                        key={idx}
                        className={`chat-message ${
                          isRight ? "sent-message" : "received-message"
                        }`}
                        onClick={() => navigate(`/profile/${msg?.senderId}`)}
                      >
                        {!isRight && (
                          <Avatar
                            src={
                              isValidUrl(msg.senderImage)
                                ? msg.senderImage
                                : PlayerImage
                            }
                            size="large"
                            className="chat-avatar-left"
                          />
                        )}

                        <div className="chat-bubble">
                          <div className="chat-meta">
                            <span className="chat-name">{msg.senderName}</span>
                            <span className="chat-time">
                              {moment(msg.timestamp).format("h:mm a")}
                            </span>
                          </div>
                          <div className="chat-content">{msg.text}</div>
                        </div>

                        {isRight && (
                          <Avatar
                            src={msg.senderImage || PlayerImage}
                            size="large"
                            className="chat-avatar-right"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="for-message-send">
                  <Input
                    placeholder="Write comment"
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                  />
                  <Button className="Fill-button send-button">
                    <img src={ArrowImage} onClick={() => handleSend()} />
                  </Button>
                </div>
              </Card>
            </div>
          </section>
        )}
        {/* ----------- Tournaments Section ----------- */}
        {(!globalSearch || hasUpcomingTournaments) && (
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Upcoming Tournaments</div>

            <div
              className={`for-live-video-grid-wrapper ${
                expanded ? "expanded" : ""
              }`}
            >
              <div className="for-feature-grid-main">
                {!tournaments || tournaments.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                    }}
                  >
                    No tournaments found
                  </p>
                ) : (
                  (tournaments || [])
                    .slice(0, expanded ? tournaments.length : 5)
                    .map((item, index) => {
                      return (
                        <div key={index} className="for-live-video-grid-inner">
                          <div
                            className="for-live-video-grid-inner-image"
                            onClick={() =>
                              navigate(
                                `/upcoming-tournaments/tournaments-details/${item._id}`,
                              )
                            }
                          >
                            <img
                              src={
                                isValidUrl(item.game.image)
                                  ? item.game.image
                                  : ImageNotAvailable
                              }
                              alt="thumbnail"
                            />
                            <span>{item.status}</span>
                            {/* <h5>2.4K watching</h5> */}
                          </div>

                          <div className="for-live-video-grid-footer">
                            <div className="player-profile">
                              <img src={PlayerProfile} alt="profile" />
                            </div>

                            <div className="for-player-text">
                              <h5>{item.game.name}</h5>
                              <p>{item.name_en}</p>

                              <div className="for-player-tags">
                                <span>{item.status}</span>
                                <span>{item.type}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                )}
              </div>
            </div>

            {/* ✅ Show button only if tournaments > 5 */}
            {tournaments && tournaments.length > 5 && (
              <div
                className="show-more-button"
                onClick={() => setExpanded(!expanded)}
              >
                <span className="line" />
                <h4>
                  {expanded ? "Show less" : "Show more"}{" "}
                  <img
                    src={ArrowDownImage}
                    alt="arrow"
                    style={{
                      transform: expanded ? "rotate(180deg)" : "rotate(0)",
                      transition: "0.3s",
                    }}
                  />
                </h4>
                <span className="line" />
              </div>
            )}
          </section>
        )}
        {/* ---------- Live Streams Section ---------- */}
        {!globalSearch && (
          <section className="live-stream-section">
            <div className="main-center-header">Livestreams</div>
            <LiveStreamCarousel />
          </section>
        )}
        {/* ---------- Featured Products ----------- */}
        {(!globalSearch || hasFeaturedProducts) && (
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Featured Products</div>
            <div
              className={`for-live-video-grid-wrapper featured-products-grid ${
                featuredexpanded ? "expanded" : ""
              }`}
            >
              <div className="for-feature-grid-main">
                {!featuredProducts || featuredProducts.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                    }}
                  >
                    No products found
                  </p>
                ) : (
                  featuredProducts.map((product) => (
                    <div className="feature-product-card" key={product._id}>
                      <img
                        src={product.images?.[0] || FeatureImage}
                        onClick={() =>
                          navigate(
                            `/stores/product/${product.vendorId}/${product._id}`,
                          )
                        }
                      />

                      <div className="feature-text">
                        <div
                          className="feature-text-innerr"
                          onClick={() =>
                            navigate(
                              `/stores/product/${product.vendorId}/${product._id}`,
                            )
                          }
                        >
                          <h5>{product.name}</h5>
                          <h6>
                            <img src={CoinImage} /> {product?.price}
                          </h6>
                        </div>

                        <span
                          className="add-plus-span"
                          onClick={() => handleAddCartItem(product._id, 1)}
                        >
                          <img src={PlusImage} />
                        </span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* ✅ Show button only if featuredProducts > 5 */}
            {featuredProducts && featuredProducts.length > 5 && (
              <div
                className="show-more-button"
                onClick={() => setFeaturedExpanded(!featuredexpanded)}
              >
                <span className="line" />
                <h4>
                  {featuredexpanded ? "Show less" : "Show more"}{" "}
                  <img
                    src={ArrowDownImage}
                    alt="arrow"
                    style={{
                      transform: featuredexpanded
                        ? "rotate(180deg)"
                        : "rotate(0)",
                      transition: "0.3s",
                    }}
                  />
                </h4>
                <span className="line" />
              </div>
            )}
          </section>
        )}
        {/* ---------- Auction Section ------------- */}
        {(!globalSearch || hasAuctions) && (
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Auctions</div>

            <div
              className={`for-live-video-grid-wrapper auctions-products-grid ${
                auctionsexpanded ? "expanded" : ""
              }`}
            >
              <div className="for-auction-main">
                {!auctions || auctions.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                    }}
                  >
                    No auctions found
                  </p>
                ) : (
                  (auctions || [])
                    .slice(0, auctionsexpanded ? auctions.length : 5)
                    .map((auction, index) => {
                      return (
                        <div key={index} className="auction-inner-card">
                          <img
                            src={
                              isValidUrl(auction.images?.[0])
                                ? auction.images[0]
                                : AuctionImage
                            }
                            alt="auction"
                          />

                          <div className="product-name">
                            <h4>{auction?.itemName}</h4>
                            <p>
                              {getDiffInTwoDate(
                                auction?.createdAt,
                                auction?.endDate,
                              )}
                            </p>
                          </div>

                          <div className="bid-price">
                            <img src={CoinImage} alt="coin" />
                            <h4>
                              Starting Bid :
                              <span className="red">
                                {auction?.startPrice} Tokens
                              </span>
                            </h4>
                          </div>

                          <div className="bid-price">
                            <img src={CoinImage} alt="coin" />
                            <h4>
                              Current Bid :
                              <span className="green">
                                {auction?.highestBidAmount} Tokens
                              </span>
                            </h4>
                          </div>

                          <Button
                            className="bid-button"
                            onClick={() =>
                              navigate(
                                `/auctions/auctions-detail/${auction?._id}`,
                              )
                            }
                          >
                            Bid Now
                          </Button>
                        </div>
                      );
                    })
                )}
              </div>
            </div>

            {/* ✅ Button appears only when more than 5 auctions exist */}
            {auctions && auctions.length > 5 && (
              <div
                className="show-more-button"
                onClick={() => setAuctionsExpanded(!auctionsexpanded)}
              >
                <span className="line" />
                <h4>
                  {auctionsexpanded ? "Show less" : "Show more"}{" "}
                  <img
                    src={ArrowDownImage}
                    alt="arrow"
                    style={{
                      transform: auctionsexpanded
                        ? "rotate(180deg)"
                        : "rotate(0)",
                      transition: "0.3s",
                    }}
                  />
                </h4>
                <span className="line" />
              </div>
            )}
          </section>
        )}
        {/* ---------- Podcast Section ------------- */}
        {(!globalSearch || hasPodcasts) && (
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Podcasts</div>

            <div
              className={`for-live-video-grid-wrapper podcast-products-grid ${
                podcastexpanded ? "expanded" : ""
              }`}
            >
              <div className="for-feature-grid-main">
                {!podcasts || podcasts.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                    }}
                  >
                    No podcasts found
                  </p>
                ) : (
                  (podcasts || [])
                    .slice(0, podcastexpanded ? podcasts.length : 5)
                    .map((item, index) => (
                      <div
                        key={index}
                        className="for-live-video-grid-inner"
                        onClick={() =>
                          navigate(`/podcasts/${item.year}/${item._id}`)
                        }
                      >
                        <div className="for-live-video-grid-inner-image">
                          <img
                            src={
                              isValidUrl(item.imageUrl)
                                ? item.imageUrl
                                : ImageNotAvailable
                            }
                            alt="thumbnail"
                          />

                          <h5>
                            <img src={ClockImage} alt="clock" /> {item?.views}
                          </h5>

                          <div className="center-image-podcasts">
                            <img
                              src={PoadcastcenterImage}
                              alt="podcast center"
                            />
                          </div>
                        </div>

                        <div className="for-live-video-grid-footer">
                          <div className="for-player-text">
                            <h5>{item.title}</h5>
                            <p>{item.player}</p>
                          </div>
                        </div>
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* ✅ Show button only if podcasts > 5 */}
            {podcasts && podcasts.length > 5 && (
              <div
                className="show-more-button"
                onClick={() => setPodcastExpanded(!podcastexpanded)}
              >
                <span className="line" />
                <h4>
                  {podcastexpanded ? "Show less" : "Show more"}
                  <img
                    src={ArrowDownImage}
                    alt="arrow"
                    style={{
                      transform: podcastexpanded
                        ? "rotate(180deg)"
                        : "rotate(0)",
                      transition: "0.3s",
                    }}
                  />
                </h4>
                <span className="line" />
              </div>
            )}
          </section>
        )}
      </Main>
    </>
  );
};

export default HomePage;
